/**
 * Arduino Get Inpired Widget
 * Injected in the PDP (arduino-product.liquid)
*/

(function() {
    function mapProjectHub(data) {
        return {
            url: 'https://projecthub.arduino.cc/' + data.posted_by + '/' + data.objectID,
            tag: 'PROJECT HUB',
            imageUrl: data.imageUrl,
            title: data.name,
            subtitle: 'Project Tutorial by ' + data.posted_by,
            text: data.one_liner
        };
    }

    function mapBlog(data) {
        return {
            url: data.permalink,
            tag: 'BLOG',
            imageUrl: data.images.thumbnail?.url,
            title: data.post_title,
            subtitle: data.post_date_formatted,
            text: data.content
        }
    }

    function mapForum(data) {
        let createdAt = new Date(1000 * data.created_at);

        return {
            url: 'https://forum.arduino.cc' + data.url,
            tag: 'FORUM',
            imageUrl: data.image_url,
            title: data.topic.title,
            subtitle: 'Last post on ' + createdAt.toDateString() + ' / by ' + data.user.username,
            text: data.content
        }
    }

    function mapSearchResults(results) {
        const posts = [];

        for(let item of results) {
            if (item.hits === undefined || item.hits.length === 0) {
                continue;
            }

            const hit = item.hits[0];

            switch(item.index) {
                case 'prod_projecthub':
                    posts.push(mapProjectHub(hit));
                    break;
                case 'prod_blog_searchable_posts':
                    posts.push(mapBlog(hit));
                    break;
                case 'discourse-posts':
                    posts.push(mapForum(hit));
                    break;
                default:
                    return;
            }
        }

        return posts;
    }

    function renderContainer(posts) {
        const getInspiredContainder = document.querySelector('#get-inspired');

        // render posts
        for(let post of posts) {
            const template = `
                <div class="ino-get-inspired-item">
                    <span class="ino-get-inspired-tag">${post.tag}</span>
                    <div class="ino-get-inspired-image">
                        <img src="${post.imageUrl}" alt="${post.title}" />
                    </div>
                    <div class="ino-get-inspired-desc">
                        <div class="ino-get-inspired-title">${post.title}</div>
                        <div class="ino-get-inspired-subtitle">${post.subtitle}</div>
                        <p class="ino-get-inspired-content" aria-hidden="true">${post.text}</p>
                    </div>
                    <span class="button-primary button-primary--small">read more</span>
                    <a class="ino-get-inspired-link" href="${post.url}" target="_blank"></a>
                </div>
            `;

            getInspiredContainder.innerHTML += template;
        }

        // strip long post text
        const getInspiredPosts = document.querySelectorAll('.ino-get-inspired-item .ino-get-inspired-content');

        for(let postElement of getInspiredPosts) {
            let style = window.getComputedStyle(postElement);
            let lineHeight = parseInt(style.lineHeight.replace('px', ''));

            if(postElement.offsetHeight > lineHeight * 3) {
                postElement.classList.add('long');
            }
        }
    }

    function init() {
        const algoliaConfig = window.algoliaShopify.config;

        if(!algoliaConfig.app_id || !algoliaConfig.search_api_key) {
            return;
        }

        const getInspiredElement = document.querySelector('#get-inspired');

        if(!getInspiredElement) {
            return;
        }

        // wait for algolia client to load
        const algoliaClient = window.algoliaShopify.searchClient;
        
        if(!algoliaClient) {
            setTimeout(init, 500);
            return;
        }

        const query = getInspiredElement.dataset.query;

        const queries = [
            {indexName: 'prod_projecthub', query: query, params: {hitsPerPage: 1}},
            {indexName: 'prod_blog_searchable_posts', query: query, params: {hitsPerPage: 1}},
            // {indexName: 'discourse-posts', query: query, params: {hitsPerPage: 1}},
        ];

        algoliaClient.multipleQueries(queries).then(({results}) => {
            return mapSearchResults(results);
        }).then((posts) => {
            if(posts.length === 0) {
                getInspiredElement.style.display = 'none';
                return;
            }

            renderContainer(posts);
        });
    }

    window.addEventListener('load', init);
})();